import { Component } from '@angular/core'

@Component({
  selector: 'app-branding-not-found',
  standalone: true,
  template: `
    <main class="not-found" aria-labelledby="branding-not-found-title">
      <div class="not-found__card" role="alert">
        <p class="not-found__code" aria-hidden="true">404</p>
        <h1 id="branding-not-found-title">Portal no encontrado</h1>
        <p>Comprueba que la dirección es correcta o contacta con tu centro médico.</p>
      </div>
    </main>
  `,
  styles: `
    :host {
      display: block;
      min-height: 100vh;
    }

    .not-found {
      min-height: 100vh;
      display: grid;
      place-items: center;
      padding: 1.5rem;
      background: var(--color-fondo-cuerpo-pagina, #e5e4e7);
      color: var(--color-texto-pagina, #211a24);
      text-align: center;
    }

    .not-found__card {
      width: min(100%, 32rem);
      padding: 2.5rem 2rem;
      border-radius: 0.75rem;
      background: #fff;
      box-shadow: 0 0.5rem 2rem rgba(33, 26, 36, 0.1);
    }

    .not-found__code {
      margin: 0 0 0.5rem;
      color: var(--color-principal);
      font-size: clamp(2.75rem, 12vw, 5rem);
      font-weight: 700;
      line-height: 1;
    }

    h1 {
      margin: 0 0 0.75rem;
      font-size: clamp(1.4rem, 5vw, 2rem);
    }

    p:last-child {
      margin: 0;
      line-height: 1.6;
    }
  `,
})
export class BrandingNotFoundComponent {}
